import { render, staticRenderFns } from "./index.vue?vue&type=template&id=affee9e8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=affee9e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affee9e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('affee9e8')) {
      api.createRecord('affee9e8', component.options)
    } else {
      api.reload('affee9e8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=affee9e8&scoped=true&", function () {
      api.rerender('affee9e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/integral/ruleShow/index.vue"
export default component.exports